import { Component } from '@angular/core';

@Component({
  selector: 'app-virtual-billing-coming-soon',
  templateUrl: './virtual-billing-coming-soon.component.html',
  styleUrls: ['./virtual-billing-coming-soon.component.css']
})
export class VirtualBillingComingSoonComponent {

}
